import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_reverse_language_notification = _resolveComponent("reverse-language-notification")
  const _component_cookie_notification = _resolveComponent("cookie-notification")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-floating-message gfu-floating-notification-box gfu-floating-notification-box--fixed _pa-0 _ma-0 _bgc--transparent _bxsh--none', $options.themeClassName])
  }, [
    _createVNode(_component_reverse_language_notification),
    ($options.isCookieConsentBannerVisible)
      ? (_openBlock(), _createBlock(_component_cookie_notification, {
          key: 0,
          "privacy-settings-url": $props.privacySettingsUrl
        }, null, 8 /* PROPS */, ["privacy-settings-url"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}